<template>
    <v-container>
        <v-app-bar id="app-bar" shrink-on-scroll prominent elevate-on-scroll app>
            <router-link class="logo-container" :to="isContractor ? { name: 'contractor-dash' } : { name: 'business-dash' }">
                <img title="Dashboard" class="app-bar-image" height="100%;" src="../../assets/Real-Deal.svg" />
            </router-link>
            <v-spacer></v-spacer>
            <div :class="showHamburgerMenu ? 'app-bar-hamburger' : 'app-bar-links'">
                <v-app-bar-nav-icon class="secondary-color" v-if="showHamburgerMenu" @click="drawer = true"></v-app-bar-nav-icon>
                <div v-else>
                    <nav-button v-if="isEstablishmentUser" :navClick="false" @click-event="navToAnalytics" toolTip="Analytics Dashboard" iconType="IMAGE" 
                        iconColorClass="secondary-color app-bar-link" :iconString="analytics"></nav-button>
                    
                    <nav-button v-if="isContractor" :navClick="false" @click-event="navToListings" toolTip="Job Listings" iconType="IMAGE" 
                        iconColorClass="secondary-color app-bar-link" :iconString="jobListingIcon"></nav-button>
                    <!-- <nav-button v-if="isContractor" :navClick="false" @click-event="navToTravel" toolTip="Explore" iconType="IMAGE" 
                        iconColorClass="secondary-color app-bar-link" :iconString="travelIcon"></nav-button> -->
                    <v-menu
                        v-if="isEstablishmentUser && partnerType >= preferredType"
                        open-on-hover
                        bottom
                        rounded="b-xl"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="secondary-color app-bar-link" icon>
                                <inline-svg height="50" width="50" class="secondary-icon secondary-color" :src="dealMenuIcon"></inline-svg>
                            </v-btn>
                        </template>
                        <v-list>
                            <router-link tag="span" :to="{ name: 'business-offering' }">
                                <v-list-item class="nav-item">
                                    <v-list-item-title class="nav-list-item"><v-icon class="secondary-color" style="margin-left: .25em;">fas fa-calendar-week</v-icon> <span>Daily Deals</span></v-list-item-title>
                                </v-list-item>
                            </router-link>
                            <router-link tag="span" :to="{ name: 'group-deals' }">
                                <v-list-item  class="nav-item">
                                    <v-list-item-title class="nav-list-item"><inline-svg height="35" width="35" class="secondary-icon" :src="showNGoPromosIcon"></inline-svg> <span>SNG Promos</span></v-list-item-title>
                                </v-list-item>
                            </router-link>
                        </v-list>
                    </v-menu>
                    <v-menu
                        v-if="isEstablishmentUser && partnerType >= premiumType"
                        open-on-hover
                        bottom
                        rounded="b-xl"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="secondary-color app-bar-link" icon>
                                <img height="50" width="50" :src="eventIcon" />
                            </v-btn>
                        </template>
                        <v-list>
                            <router-link tag="span" :to="{ name: 'business-organize-event' }">
                                <v-list-item class="nav-item">
                                    <v-list-item-title class="nav-list-item"><img height="35" width="35" :src="organizeEvent" /> <span>Organize Event</span></v-list-item-title>
                                </v-list-item>
                            </router-link>
                            <router-link tag="span" :to="{ name: 'event-schedule' }">
                                <v-list-item  class="nav-item">
                                    <v-list-item-title class="nav-list-item"><img height="35" width="35" :src="eventSchedule" /> <span>Event Schedule</span></v-list-item-title>
                                </v-list-item>
                            </router-link>
                        </v-list>
                    </v-menu>
                    <v-menu
                        open-on-hover
                        bottom
                        nudge-top="2"
                        rounded="b-xl"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="secondary-color app-bar-link" icon>
                                <v-badge :content="cartCount" :value="cartCount" color="#EE1D00"><v-icon>fas fa-users-cog</v-icon></v-badge>
                            </v-btn>
                        </template>
                        <v-list>
                            <router-link tag="span" :to="{ name: 'settings' }">
                                <v-list-item class="nav-item">
                                    <v-list-item-title><v-icon class="primary-color" style="float: left;">fas fa-cogs</v-icon> Settings</v-list-item-title>
                                </v-list-item>
                            </router-link>
                            <v-list-item @click="openPaymentDialog" class="nav-item">
                                <v-list-item-title style="display: flex; align-items: center;">
                                    <v-badge v-if="cartCount" :content="cartCount" :value="cartCount" color="#EE1D00" style="margin-right: 2em;"><v-icon class="primary-color">fas fa-shopping-cart</v-icon></v-badge>
                                    <v-icon v-else style="float: left; margin-right: 1.25em;" class="primary-color">fas fa-shopping-cart</v-icon>
                                    Cart
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="signOut" class="nav-item">
                                <v-list-item-title><v-icon class="primary-color" style="float: left;">fas fa-sign-out-alt</v-icon> Sign Out</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </v-app-bar>
        <v-navigation-drawer v-model="drawerControl" absolute temporary>
            <v-list nav>
                <v-list-item-group v-model="group" active-class="active-hamburger">
                    <router-link v-if="isContractor && partnerType >= premiumType" tag="span" :to="{ name: 'job-listings' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon class="center">
                                <img height="50" width="50" :src="jobListingIcon" />
                            </v-list-item-icon>
                            <v-list-item-title>Local Listings</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    <router-link v-if="isEstablishmentUser && partnerType >= premiumType" tag="span" :to="{ name: 'business-organize-event' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon class="center">
                                <img height="50" width="50" :src="organizeEvent" />
                            </v-list-item-icon>
                            <v-list-item-title>Organize Event</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    <router-link v-if="isEstablishmentUser && partnerType >= premiumType" tag="span" :to="{ name: 'event-schedule' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon class="center">
                                <img height="50" width="50" :src="eventSchedule" />
                            </v-list-item-icon>
                            <v-list-item-title>Event Schedule</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    <router-link v-if="isEstablishmentUser && partnerType === preferredType" tag="span" :to="{ name: 'group-deals' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon>
                                <img height="50" width="50" :src="showNGoPromosIcon" />
                            </v-list-item-icon>
                            <v-list-item-title>Show N Go Promos</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    <router-link v-if="isEstablishmentUser && partnerType >= premiumType" tag="span" :to="{ name: 'advertisement-dash' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon class="center">
                                <img height="50" width="50" :src="markerBillboard" />
                            </v-list-item-icon>
                            <v-list-item-title>Ad Dashboard</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    <router-link tag="span" :to="{ name: 'business-offering' }">
                        <v-list-item class="hamburger-item">
                            <v-list-item-icon>
                                <v-icon class="secondary-color" size="50px">fas fa-calendar-week</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Edit Daily Deals</v-list-item-title>
                        </v-list-item>
                    </router-link>
                </v-list-item-group>
            </v-list>
            <v-row class="center">
                <site-button
                    :colNum="3"
                    @click-event="signOut"
                    colorClasses="primary-color"
                    toolTip="Sign Out"
                    iconString="fas fa-sign-out-alt"
                ></site-button>
                <site-button
                    :colNum="3"
                    colorClasses="primary-color"
                    toolTip="Business Settings"
                    iconString="fas fa-cogs"
                    @click-event="navToSettings"
                ></site-button>
                <v-badge :content="cartCount" :value="cartCount" color="#EE1D00" overlap>
                    <site-button
                        :colNum="3"
                        colorClasses="primary-color"
                        toolTip="Cart"
                        iconString="fas fa-shopping-cart"
                        @click-event="openPaymentDialog"
                    ></site-button>
                </v-badge>
            </v-row>
        </v-navigation-drawer>
    </v-container>
</template>

<style lang="scss" scoped>

.cart-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.nav-list-item{
    display: flex;
    justify-content: space-between;
    align-items: center;

    span{
        margin-left: 10px;
    }
}
</style>

<script>
import SiteButton from '../common/SiteButton';
import PartnerTypeEnums from '../../assets/Enums/PartnerTypeEnum';
import InlineSvg from 'vue-inline-svg';
import NavButton from './NavButton';

export default {
    name: 'business-navigation',
    components: {
        'site-button': SiteButton,
        'inline-svg': InlineSvg,
        'nav-button': NavButton
    },
    data: () => ({
        drawer: false,
        group: null,
    }),
    methods: {
        signOut() {
            console.log('sign out');
            this.$store.dispatch('AUTH_LOGOUT')
                .then(() => {
                    console.log('logged out');
                    this.$router.push({ name: 'home-page' });
                })
                .catch(e => {
                    this.$router.push({ name: 'home-page' });
                    console.log(e);
                });
        },
        navToAnalytics(){
            if(this.$store.getters.isEstablishment) {
                this.$router.push({ name: 'advertisement-dash' });
            } else if(this.$store.getters.isContractor) {
                this.$router.push({ name: 'contractor-dash' });
            }
        },
        navToListings() {
            this.$router.push({ name: 'contract-listings' });
        },
        navToTravel() {
            this.$router.push({ name: 'contractor-relocate' });
        },
        navToSettings(){
            this.$router.push({ name: 'settings' });
        },
        openPaymentDialog(){
            console.log('SHOW');
            this.$store.dispatch('SHOW_PAYMENT_DIALOG');
        }
    },
    computed: {
        drawerControl: {
            get() {
                return this.drawer && this.showHamburgerMenu
            },
            set(newVal) {
                this.drawer = newVal
            },
        },
        isEstablishmentUser() {
            return this.$store.getters.isEstablishment;
        },
        isPlannerUser() {
            return this.$store.getters.isPlanner;
        },
        isContractor() {
            return this.$store.getters.isContractor;
        },
        limitedType(){
            return PartnerTypeEnums.LIMITED.number;
        },
        premiumType(){
            return PartnerTypeEnums.PREMIUM.number;
        },
        preferredType(){
            return PartnerTypeEnums.PREFERRED.number;
        },
        partnerType(){
            return this.$store.getters.partnerType;
        },
        markerBillboard() {
            return require('../../assets/DN-Marker-Billboard.svg');
        },
        analytics(){
            return require('../../assets/Analytics.svg');
        },
        eventIcon(){
            return require('../../assets/Event-Icon.svg');
        },
        primaryEventIcon(){
            return require('../../assets/Event-Icon-Primary.svg');
        },
        sliderAdImg(){
            return require('../../assets/Slider-Ad.svg');
        },
        cardAdImg(){
            return require('../../assets/Card-Ads.svg');
        },
        organizeEvent(){
            return require('../../assets/Organize-Event.svg');
        },
        eventSchedule(){
            return require('../../assets/Event-Schedule.svg');
        },
        showNGoPromosIcon(){
            return require('../../assets/Show-N-Go-Icon.svg');
        },
        dealMenuIcon(){
            return require('../../assets/Deals-Menu.svg');
        },
        jobListingIcon() {
            return require('../../assets/Job-Listing-Icon.svg');
        },
        travelIcon() {
            return require('../../assets/Relocate.svg');
        },
        showHamburgerMenu() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                case 'sm':
                    return screen.width <= 768 ? true : false
                default:
                    return false
            }
        },
        cartCount(){
            return (this.$store.state.sessionCharges || []).length;
        }
    },
}
</script>
